const questions = [
    {
        id:"1",
        question:"Quanto de dinheiro eu preciso para fazer o pagamento inicial?",
        answer:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"2",
        question:"Quanto eu tenho que pagar para um agete me ajudar a comprar uma casa?",
        answer:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"3",
        question:"Qual é o primeiro passo para o processo de compra da casa?",
        answer:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
]
export default questions